import MUIGrid, { Grid2Props } from '@mui/material/Unstable_Grid2';

export type GridProps = Grid2Props;
export const Grid = MUIGrid;
